function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M12.7 8.5h-1.5V18h1.5V8.5zM16 8.5h-1.5L14 18h1.5l.5-9.5zM10 18l-.5-9.5H8l.5 9.5H10z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.5 5.5V4c0-.8-.7-1.5-1.5-1.5h-4c-.8 0-1.5.7-1.5 1.5v1.5H3V7h1.5l1.4 13.2c.1.8.7 1.3 1.5 1.3h9.3c.8 0 1.4-.6 1.5-1.3L19.5 7H21V5.5h-5.5zM10 4h4v1.5h-4V4zm6.6 16H7.4L6 7h12l-1.4 13z"
});

function SvgDeleteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "currentColor"
  }, props), _ref, _ref2);
}

export default SvgDeleteIcon;